// removed by extract-text-webpack-plugin
module.exports = {"InstallationInfo":"HJeEyZtpWtaUPtpxX6XH8","InstallScriptBorder":"V2SS8SU2hSV6JkhUK8nQ0","InstallScriptText":"bOj48EuOwvDmcrRVvkv8T","CopyButton":"_35lWBngpW-fo_qzsAtLrFF","ExampleCodeWrapper":"_2JPnNep00G-x6ektxl-ncl","ExampleCodeBorder":"bmsSiO0Lv3ktS0b-M4N1K","ExampleCode":"_3SJDtZidkEZVbAEybLqepg","SeeExampleText":"_2BiMW95mcJ3B9s1HETwH2t","DemoLink":"_1BxNJeMKN4LSfKkoyq6CFf","BubbleRow":"_3U41bCZF4omwJ62G1ZT9O7"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/CompanySettings/Installation/style.css
// module id = 1994
// module chunks = 0